import React, {useState} from "react";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {BaseInput} from "../../../../designSystem/components/BaseInput";

interface PasswordInputProps {
  value: string;
  onChange: (value: string) => void;
}

export const PasswordInput = ({
  value,
  onChange,
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <div className="relative">
      <BaseInput
        value={value}
        onChange={e => onChange(e.target.value)}
        type={showPassword ? "text" : "password"}
        placeholder="輸入密碼"
      />
      <div className="absolute right-1 top-1/2 transform -translate-y-1/2">
        <ActionButton
          variant="ghost"
          size="lg"
          iconName={showPassword ? 'fa-eye-slash' : 'fa-eye'}
          onClick={toggleShowPassword}
        />
      </div>
    </div>
  )

}